import {Component, Injector, OnInit} from '@angular/core';
import {PomodoroRepository} from '../../Models/PomodoroRepository';
import {FormControl} from '@angular/forms';
import {Pomodoro} from '../../Models/Pomodoro';
import {CategoryService} from '../../services/category.service';
import {TodoService} from '../../services/todo.service';
import {Todo} from '../../Models/todo.model';
import * as moment from 'moment';
import {CdkDragDrop, moveItemInArray, transferArrayItem} from '@angular/cdk/drag-drop';
@Component({
  selector: 'app-todolist',
  templateUrl: './todolist.component.html',
  styleUrls: ['./todolist.component.css']
})
export class TodolistComponent implements OnInit {
  public pomodoroRepository: PomodoroRepository;
  public myControl = new FormControl();
  public pomodoro = new Pomodoro();
  public todo = new Todo();
  public haveToken;
  public todosList;
  public markedTodos;
  public markAllCtrl = false;
  public showImportToMainButton = false;
  constructor(public injector: Injector,
              private categoryService: CategoryService,
              private todoService: TodoService) {
    this.pomodoroRepository = PomodoroRepository.getInstance(injector);
  }
  ngOnInit(): void {
    const token = localStorage.getItem('token');
    this.haveToken = token !== null;
    this.pomodoroRepository.getListOfTodos();
    // this.pomodoroRepository.deleteAllTodods();
  }
  saveToCategories(i): void {
    this.pomodoroRepository.categories.push(i);
    if (this.haveToken){
      this.categoryService.syncCategory(this.pomodoroRepository.categories).subscribe();
      this.pomodoroRepository.save();
    }
  }
  addItem(): void {
    this.todo.user_id = localStorage.getItem('userId');
    this.pomodoroRepository.addToTodos(this.todo);
    this.todo = new Todo();
  }
  deleteItem(item): any{
    this.pomodoroRepository.deleteTodos(item.id);
  }
  logAllTasks(): any{
  }
  addToPomodoroList(t): any{
    if (Array.isArray(t)){
      // tslint:disable-next-line:prefer-for-of
      for (let i = 0; i < t.length ; i++) {
        const pomo = new Pomodoro();
        pomo.category = t[i].category_title;
        pomo.count = 1;
        pomo.created_at = moment().format('YYYY-MM-DD HH:mm:ss');
        pomo.description = t[i].desc;
        pomo.done = false;
        pomo.isEdit = false;
        pomo.time_length = this.pomodoroRepository.defaultMeasure;
        this.pomodoroRepository.addItem(pomo);
        this.pomodoroRepository.isReversed = localStorage.getItem('isReverse');
        setTimeout(() => {
          this.showImportToMainButton = false;
        }, 3000);
      }
    } else {
      const p = new Pomodoro();
      p.category = t.category_title;
      p.count = 1;
      p.created_at = moment().format('YYYY-MM-DD HH:mm:ss');
      p.description = t.desc;
      p.done = false;
      p.isEdit = false;
      p.time_length = this.pomodoroRepository.defaultMeasure;
      this.pomodoroRepository.addItem(p);
      this.pomodoroRepository.isReversed = localStorage.getItem('isReverse');
      setTimeout(() => {
        this.showImportToMainButton = false;
      }, 3000);
    }
  }
  deleteAllTodos(): any{
    this.pomodoroRepository.deleteAllTodods();
  }
   markAllTodos(ctrl): any{
     // tslint:disable-next-line:prefer-for-of
     for (let i = 0; i < this.pomodoroRepository.todosList.length ; i++) {
       if (ctrl){
         this.pomodoroRepository.todosList.map((item) => item.is_mark = false);
       } else {
         this.pomodoroRepository.todosList.map((item) => item.is_mark = true);
       }
     }
     if (this.pomodoroRepository.todosList.every(i => i.is_mark === false)){
       this.showImportToMainButton = false;
     }
  }
  drop(event: CdkDragDrop<Todo[]>): void {
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      transferArrayItem(event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex);
    }
    this.pomodoroRepository.save();
  }
   addAllToMainPage(): any{
    // tslint:disable-next-line:prefer-for-of
    for (let i = 0; i < this.pomodoroRepository.todosList.length ; i++) {
      this.markedTodos = this.pomodoroRepository.todosList.filter( item => item.is_mark);
    }
    console.log(this.markedTodos);
    console.log(this.pomodoroRepository.todosList.every(i => i.is_mark === false));
    this.addToPomodoroList(this.markedTodos);
    if (this.pomodoroRepository.todosList.every(i => i.is_mark === true)){
       this.deleteAllTodos();
     } else {
      // tslint:disable-next-line:prefer-for-of
      for (let p = 0; p < this.markedTodos.length; p++) {
          this.pomodoroRepository.deleteTodos(this.markedTodos[p].id);
      }
    }
    setTimeout(() => {
      this.markAllCtrl = false;
    }, 2000);
    }
  addOneToMainPage(todo): any{
    this.addToPomodoroList(todo);
    this.deleteItem(todo);
  }
  markOneTask(item): any{
    if (item.is_mark){
      item.is_mark = false;
      if (this.pomodoroRepository.todosList.every(i => i.is_mark === false)){
        this.showImportToMainButton = false;
      }
    } else {
      item.is_mark = true;
      this.showImportToMainButton = true;
    }
  }
  editTodo(item): any{
    console.log(item);
  }
  showInput(i: any): any {
    i.is_edit = true;
    // @ts-ignore
    this.myControl.value = '';
    // this.myControl.value = i.category_title;
  }

  backToDes(item): void {
    console.log(item);
    const todo = {
      desc: item.desc,
      category_title: item.category_title
    };
    this.todoService.updateTodo(todo, item.id).subscribe(
      () => {
        item.is_edit = false;
      }
    );
  }
  saveToCategoriesTasks(i): void {
    if (i.category === ''){
      i.category = null;
    }
    if (i.category !== ''){
      this.pomodoroRepository.categories.push(i.category);
      i.is_edit = false;
      this.categoryService.syncCategory(this.pomodoroRepository.categories).subscribe();
      this.backToDes(i);
      this.pomodoroRepository.save();
    }
  }
}
